<template>
  <v-container fill-height>
    <v-row class="text-center" align="center" style="height: 100%;">
      <v-col  v-if="serie == 0"
              cols="12" >

        <register-card v-if="currentCard == 0"></register-card>
        
        <info-card   v-if="currentCard == 1" :block="getCurrentBlock('1-intro')"   title="Instrucciones"></info-card>
        
        <info-card   v-if="currentCard == 2" :block="getCurrentBlock(randomBlock3[0])"   title="Instrucciones"></info-card>
        
        <block-card  v-if="currentCard == 3" :block="getCurrentBlock(randomBlock3[1])"></block-card>
        
        <info-card   v-if="currentCard == 4" :block="getCurrentBlock(randomBlock3[2])"   title="Instrucciones"></info-card>
        
        <block-card  v-if="currentCard == 5" :block="getCurrentBlock(randomBlock3[3])"></block-card>

        <info-card   v-if="currentCard == 6" :block="getCurrentBlock(randomBlock3[4])"   title="Instrucciones"></info-card>

        <block-card  v-if="currentCard == 7" :block="getCurrentBlock(randomBlock3[5])"></block-card>

        <info-card   v-if="currentCard == 8" :block="getCurrentBlock('4-intro')"   title="Instrucciones"></info-card>

        <block-valence-card  v-if="currentCard == 9" :block="getCurrentBlock('4')"></block-valence-card>

        <final-card   v-if="currentCard == 10" :block="getCurrentBlock('final')"   title="Final"></final-card>
      
      </v-col>
      <v-col  v-else
              cols="12" >
        <register-card v-if="currentCard == 0"></register-card>
        
        <info-card   v-if="currentCard == 1" :block="getCurrentBlock('1-intro')"   title="Instrucciones"></info-card>

        <info-card   v-if="currentCard == 2" :block="getCurrentBlock('4-intro')"   title="Instrucciones"></info-card>

        <block-valence-card  v-if="currentCard == 3" :block="getCurrentBlock('4')"></block-valence-card>
        
        <info-card   v-if="currentCard == 4" :block="getCurrentBlock(randomBlock3[0])"   title="Instrucciones"></info-card>
        
        <block-card  v-if="currentCard == 5" :block="getCurrentBlock(randomBlock3[1])"></block-card>
        
        <info-card   v-if="currentCard == 6" :block="getCurrentBlock(randomBlock3[2])"   title="Instrucciones"></info-card>
        
        <block-card  v-if="currentCard == 7" :block="getCurrentBlock(randomBlock3[3])"></block-card>

        <info-card   v-if="currentCard == 8" :block="getCurrentBlock(randomBlock3[4])"   title="Instrucciones"></info-card>

        <block-card  v-if="currentCard == 9" :block="getCurrentBlock(randomBlock3[5])"></block-card>   

        <final-card   v-if="currentCard == 10" :block="getCurrentBlock('final')" title="Final"></final-card>     
      
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import RegisterCard from './cards/RegisterCard.vue'
  import InfoCard from './cards/InfoCard.vue'
  import BlockCard from './cards/BlockCard.vue'
  import BlockValenceCard from './cards/BlockValenceCard.vue'
  import FinalCard from './cards/FinalCard.vue'
  import { blocks } from '../tools/data'
  
  export default {
    name: 'HomePoint',
    components: { RegisterCard,
                  InfoCard,
                  BlockCard,
                  BlockValenceCard,
                  FinalCard
                  },
    data: () => ({
          
    }),
    mounted(){
      console.log("Serie: ",this.serie)
      console.log("Block 3 order:", this.randomBlock3)
    },
    methods:{
      getCurrentBlock(blockId){        
        return blocks.find(b => b.blockId == blockId)
      }     
    },
    computed:{
      currentCard(){   
        return this.$store.state.currentCard
      },
      serie(){
        return this.$store.state.serie
      },
      randomBlock3(){
        return this.$store.state.randomBlock3
      },    
    }
  }
</script>
